import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { checkCustomerSession } from "@/services/session";

const CustomerLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    (async () => {
      const ok = await checkCustomerSession();
      if (!alive) return;
      if (ok) navigate("/customer/dashboard", { replace: true });
      else navigate("/", { replace: true });
    })();
    return () => {
      alive = false;
    };
  }, [navigate]);

  return <div className="p-6 text-center">Redirecting…</div>;
};

export default CustomerLogin;
